export const ALL_LESSONS_NAME = 'Units 1-4'
